export class ErrorReporter {
    private sendingJsError: boolean = false;
    private readonly urlErrors: string = '/errorReport/api_frontend_js_error/';

    constructor() {
        window.onerror = this.handleGlobalError.bind(this);
        window.addEventListener("unhandledrejection", this.handlePromiseRejection.bind(this));
    }

    private handleGlobalError(
        eventOrMessage: Event | string,
        source?: string,
        lineno?: number,
        colno?: number,
        error?: Error
    ): void {
        if (typeof eventOrMessage === 'string') {
            this.reportError(eventOrMessage, source || null, lineno || null, colno || null, error?.stack ?? null);
        }
    }

    private handlePromiseRejection(event: PromiseRejectionEvent): void {
        const reason = event.reason;

        if (reason instanceof Error) {
            const lineNumber = (reason as any).lineNumber ?? null;
            const columnNumber = (reason as any).columnNumber ?? null;

            this.reportError(
                reason.message,
                null,
                lineNumber,
                columnNumber,
                reason.stack ?? null
            );
        } else {
            console.error("Unhandled rejection with non-error reason:", reason);
        }
    }

    public reportError(
        errorMsg: string,
        errorUrl: string | null,
        errorLineNumber: number | null,
        errorColumn: number | null,
        errorObj: string | null
    ): void {
        // Do not report external errors on the entry page.
        if (document.querySelector('body')?.classList.contains('clx-entrypage')) {
            return;
        }

        // Don't log errors for crawler requests
        if (document.querySelector('body')?.classList.contains('crawler-request')) {
            return;
        }

        // Skip errors, that occure while aborting a fetch request.
        if (errorMsg.toLowerCase().indexOf('networkerror when attempting to fetch resource') !== -1) {
            return;
        }
        if (errorMsg.toLowerCase().indexOf('load failed') !== -1) {
            return;
        }
        if (errorMsg.toLowerCase().indexOf('failed to fetch') !== -1) {
            return;
        }
        if (errorMsg.toLowerCase().indexOf('the operation was aborted') !== -1) {
            return;
        }

        if (!this.sendingJsError && errorMsg.toLowerCase().indexOf("script error") === -1) {
            this.sendingJsError = true;

           // errorMsg = errorMsg + ' DebugInfos: appName: '+ navigator.appName + ' - appVersion: '+navigator.appVersion + ' - userAgent: '+ navigator.userAgent;
           // errorMsg = errorMsg +  '- cookieEnabled: '+  navigator.cookieEnabled;
            //errorMsg = errorMsg +  '- Bildschirmaufloesung: width x height: '+  window.screen.width + 'x' + window.screen.height;
            //errorMsg = errorMsg +  '- Viewport: width x height: '+  window.innerWidth + 'x' + window.innerHeight;



            const data = new FormData();
            data.append("errorMsg", errorMsg);
            data.append("errorUrl", errorUrl || '');
            data.append("errorLineNumber", errorLineNumber?.toString() || '');
            data.append("errorColumn", errorColumn?.toString() || '');
            data.append("errorLocation", window.location.href);
            data.append("errorObj", errorObj || '');

            fetch(this.urlErrors, {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                },
                credentials: 'same-origin',
                body: data,
            }).finally(() => {
                this.sendingJsError = false;
            });
        }
    }

}
